import React, { useState } from "react";
import { Link } from "gatsby";
import QuotePopUp from "components/popup/quotePopUp/index";
import ContactusMobile from "components/reusableComponents/contactusMobile/ContactusMobile";
import arrowDownSvg from "assets/icons/arrow-down-circle.svg";
import OptimizedImage from "hooks/OptimizedImage";

export default function Banner() {
  const [open, setOpen] = useState(false);
  const [openContactusMobile, setOpenContactusMobile] = useState(false);

  const transitionStyle = {
    transition: "all .3s",
  };

  return (
    <section className="bg-[#E8F1F5] md:bg-desktop bg-no-repeat bg-cover object-contain -mb-4 sm:-mb-8 ">
      <div className=" mx-auto flex flex-col pb-8 w-11/12 px-2 sm:px-0 sm:w-[90%]  pt-5 md:pt-16 lg:max-w-7xl">
        <h1 className="font-secondary font-extrabold text-[#00173a] text-[36px] md:text-46 mb-2 w-full md:w-[80%] break-normal md:hidden">Professional Translation Services On a Global Scale</h1>
        <h1 className="font-secondary font-extrabold text-[#00173a] text-[32px] lg:text-46 mb-2 w-full  break-normal hidden md:block">
          Professional Translation Services
          <br />
          On a Global Scale
        </h1>
        <p className="font-opensans text-17 sm:text-[20px] leading-8 text-[#00173a] mb-6 w-full md:w-full lg:w-[85%]">
          At Tomedes, we've made it our mission to provide professional translation services that leave a lasting impression. Our human translators are up for the challenge, whichever translation you
          need, standard document or certified. We speak your language to convey your meaning to the world easily.
        </p>
        <div className="inline-flex flex-col md:flex-row justify-start items-start md:items-center gap-7 font-opensans">
          <Link
            to="/quote"
            className="fr-btn1 uppercase rounded-full bg-orange hover:bg-[#ff9a16] text-white cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-all duration-300"
          >
            Translate Now
          </Link>
          <a
            onClick={() => setOpen(true)}
            className="hidden md:block fr-btn2 uppercase rounded-full bg-white text-[#000101] hover:bg-orange hover:text-white  cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-all duration-300"
          >
            Contact Us
          </a>
          <a
            onClick={() => setOpenContactusMobile(true)}
            className="md:hidden fr-btn2 uppercase rounded-full bg-midBlue hover:bg-[#042E6E] text-white cursor-pointer text-17 font-semibold py-4 px-8 w-[253px] text-center transition-all duration-300 relative"
          >
            Contact Us <img src={arrowDownSvg} alt="arrow down" className={`${openContactusMobile ? "visible" : "invisible"} absolute right-6 top-5`} />
          </a>
          <ContactusMobile open={openContactusMobile} setOpen={setOpenContactusMobile} />
        </div>
        <ul className="flex lg:flex-row flex-col text-midBlue md:text-white sm:justify-between  lg:mx-auto  xl:justify-evenly pt-20 gap-x-10 lg:gap-y-0 gap-y-8 mt-7 pb-[40px] md:pb-24">
          <li className="flex items-center">
            <OptimizedImage src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/call-center.svg" alt=""  className="w-[53px] lg:w-[40px] h-[53px] lg:h-[40px]"/>
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">Available Online 24/7</p>
          </li>
          <li className="flex items-center">
            <OptimizedImage src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/badge.svg" alt="" className="w-[53px] lg:w-[40px] h-[70px] lg:h-[52px]" />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">1-Year Guarantee</p>
          </li>
          <li className="flex items-center">
            <OptimizedImage src="https://tomedes.gumlet.io/assets/images/new-homepage-assets/desktop/Group.svg" alt="" className="w-[53px] lg:w-[40px] h-11 lg:h-8" />
            <p className="text-[20px] sm:text-[25px] font-semibold pl-4 lg:text-left text-center">95,000 Business Customers</p>
          </li>
        </ul>

        <ul className="flex flex-wrap justify-center items-center gap-x-8 gap-y-8 pt-20  relative">
          <li class="m-margin flex">
            <a href="https://search.google.com/local/reviews?placeid=ChIJDZbF04sNlVQRbsAJdqiC_uw">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_US.svg" alt="google reviews USA" className="w-52 h-[58px]" />
            </a>
          </li>
          <li class="m-margin flex">
            <a href="https://search.google.com/local/reviews?placeid=ChIJV2mjZn1LHRURjGNyBoW-qUs">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/reviews-images-updated/Review_IL.svg" alt="google reviews Israel" className="w-52 h-[58px]" />
            </a>
          </li>
          <li class="m-margin flex">
            <a href="https://clutch.co/profile/tomedes-1#reviews">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/reviews-images-updated/clutch.svg" alt="clutch reviews" className="w-52 h-[58px]" />
            </a>
          </li>
          <li class="m-margin flex">
            <a href="https://www.goodfirms.co/company/tomedes">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/reviews-images-updated/goodfirms.svg" alt="goodfirms reviews" className="w-52 h-[58px]" />
            </a>
          </li>
          </ul>
          <ul className="flex flex-wrap justify-center items-center gap-x-8 gap-y-8 pt-20  relative mb-16">
            <li class="m-margin flex">
            <a href="https://www.trustpilot.com/review/www.tomedes.com">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/reviews-images-updated/trustpilot.svg" alt="trustpilot reviews" className="w-52 h-[58px]" />
            </a>
          </li>
          <li >
            <a href="https://www.g2.com/products/tomedes/reviews" target="_blank" className="flex">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/g2_review.svg" alt="g2 reviews" className="w-52 h-[58px]" />
            </a>
          </li>
          <li>
            <a href="https://www.facebook.com/Tomedes.translation/reviews" target="_blank" className="flex">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/facebook_review.svg" alt="fb reviews" className="w-52 h-[58px]" />
            </a>
          </li>
          <li>
            <a href="https://www.featuredcustomers.com/vendor/tomedes" target="_blank" className="flex">
              <OptimizedImage src="https://tomedes.gumlet.io/assets/images/featured_review.svg" alt="featured reviews" className="w-52 h-[58px]" />
            </a>
          </li>
        </ul>
      </div>
      <QuotePopUp open={open} setOpen={setOpen} />
    </section>
  );
}
